// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_17tnpk4uAmqWupWS9WktPF","container":"_2l56LiAZZWBXblB__phSCl","slide":"_5I62k21Vlm4-gry0z6ip6","image-wrapper":"fFmYzhkHbY2u0bL2v1HuW","image":"_3mP1V5AJzEfLI_7h_g-saB","navigation":"_2L2d1fPDscM4lp7gPjV7XO","nav-wrapper":"_3XYfrTgcgZTgdkBVUNHA9u","nav-container":"_3O3P1PWQkYR6jI4C1EBzgi","nav":"_2Of3MxP_8offxHZ62if-Tx","icon":"_2eXEzGuKsikv_FTlFxuPBJ","prev":"bWswQR0ihwLAQ5vWemLDj","next":"_15Mpxh6IDFtpZcQ6CwrSMr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/SlideshowStep.mod.css
// module id = 1696
// module chunks = 0